// extracted by mini-css-extract-plugin
export default {"btn":"BackToTop_btn__lIxRw"};